var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "pad30" },
        [
          _c("h2", { staticClass: "f18 fb normal gray_2" }, [
            _vm._v("口碑视频管理")
          ]),
          _c("div", { staticClass: "box20" }),
          _c(
            "div",
            { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "w150 mar20_r",
                    attrs: { placeholder: "请输入商品关键字" },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              ),
              _c("el-button", { on: { click: _vm.getList } }, [_vm._v("查询")]),
              _c(
                "el-button",
                {
                  staticClass: "mar-20-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.chooseGoods }
                },
                [_vm._v("引入商品")]
              ),
              _vm.selfOperatedShop
                ? _c(
                    "el-button",
                    {
                      staticClass: "mar-20-l",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.bindVlogId(_vm.weChatChannelOpenId)
                        }
                      }
                    },
                    [_vm._v("绑定视频号")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.dataList, "row-key": "targetId" },
              on: { "selection-change": _vm.kbVlogSelect }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "name",
                  label: "商品名称"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "detailAmount", label: "视频数量" }
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.editActivity(scope.row)
                                }
                              }
                            },
                            [_vm._v("上传视频")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "mar15-l",
                              on: {
                                click: function($event) {
                                  return _vm.deleteInfo(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2535093744
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center mar20-t" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: this.multipleSelection.length == 0
                  },
                  on: { click: _vm.deleteList }
                },
                [_vm._v("批量删除 ")]
              ),
              _c("div", { staticClass: "gray9 flex-auto mar-20-l" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.pageTotal) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.totalPage) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next, sizes, jumper",
                  background: "",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.totalPage,
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 20, 30]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择商品",
                visible: _vm.chooseGoodVisible,
                "close-on-click-modal": false,
                width: "945px",
                top: "80px",
                "show-close": false,
                "custom-class": "chooseGoodPop"
              },
              on: {
                "update:visible": function($event) {
                  _vm.chooseGoodVisible = $event
                }
              }
            },
            [
              _c("div", [
                _c("div", { staticClass: "clear ps_search_wrap" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "float-left pad15_r lin_30 inlineblock gray_3"
                    },
                    [_vm._v("货品名称")]
                  ),
                  _c(
                    "div",
                    { staticClass: "ps_search float-left" },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入货品名称" },
                        model: {
                          value: _vm.searchGoods.name,
                          callback: function($$v) {
                            _vm.$set(_vm.searchGoods, "name", $$v)
                          },
                          expression: "searchGoods.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "float-left client_pop_query",
                      on: {
                        click: function($event) {
                          return _vm.getPriceGoodsList(1)
                        }
                      }
                    },
                    [_vm._v("搜索")]
                  )
                ]),
                _c("div", { staticClass: "box20" }),
                _c("div", { staticClass: "clear appoint_goods_list" }, [
                  _c("div", { staticClass: "float-left client_list_all" }, [
                    _c("p", { staticClass: "gray_3" }, [_vm._v("本店货品")]),
                    _c("div", { staticClass: "client_list_wrap" }, [
                      _c(
                        "ul",
                        { staticClass: "clear" },
                        _vm._l(_vm.goodsDataList, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: [item.activityUsed ? "opacity3" : ""],
                              on: {
                                click: function($event) {
                                  return _vm.goodsDialogSelect(item)
                                }
                              }
                            },
                            [
                              item.mainPicUrl
                                ? _c("img", {
                                    staticClass: "float-left appoint_good_img",
                                    attrs: { src: item.mainPicUrl, alt: "" }
                                  })
                                : _c("img", {
                                    staticClass: "float-left appoint_good_img",
                                    attrs: {
                                      src: require("@/assets/images/goods_small.jpg"),
                                      alt: ""
                                    }
                                  }),
                              _c(
                                "div",
                                { staticClass: "float-left appoint_good_main" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ellipsis_two f14 gray_3",
                                      attrs: { title: item.name }
                                    },
                                    [_vm._v(_vm._s(item.spuName))]
                                  ),
                                  item.activityUsed
                                    ? _c("p", { staticClass: "f16 mar10-t" }, [
                                        _vm._v("已添加")
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "float-right client_list_me" }, [
                    _c("p", { staticClass: "gray_3" }, [_vm._v("已选货品")]),
                    _c("div", { staticClass: "client_list_wrap" }, [
                      _c(
                        "ul",
                        { staticClass: "clear" },
                        _vm._l(_vm.goodsSelectList, function(item, index) {
                          return _c("li", { key: index }, [
                            _c("i", {
                              staticClass: "iconfont icon-shibai fb",
                              on: {
                                click: function($event) {
                                  return _vm.removeSelectGoods(item)
                                }
                              }
                            }),
                            item.mainPicUrl
                              ? _c("img", {
                                  staticClass: "float-left appoint_good_img",
                                  attrs: { src: item.mainPicUrl, alt: "" }
                                })
                              : _c("img", {
                                  staticClass: "float-left appoint_good_img",
                                  attrs: {
                                    src: require("@/assets/images/goods_small.jpg"),
                                    alt: ""
                                  }
                                }),
                            _c(
                              "div",
                              { staticClass: "float-left appoint_good_main" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "ellipsis_two f14 gray_3",
                                    attrs: { title: item.name }
                                  },
                                  [_vm._v(_vm._s(item.spuName))]
                                ),
                                _c("p", { staticClass: "f12 gray_6" })
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "box20" })
              ]),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.currentPage2,
                  "page-sizes": [10, 20, 30],
                  "page-size": _vm.pageSize2,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalCount2
                },
                on: {
                  "size-change": _vm.handleSizeChange2,
                  "current-change": _vm.handleCurrentChange2
                }
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goodsDialogConfirm }
                    },
                    [_vm._v("确 认")]
                  ),
                  _c("el-button", { on: { click: _vm.goodsDialogClose } }, [
                    _vm._v("取 消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c("div", { staticStyle: { "min-height": "900px" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }